window.audio_path = (name) => {
  return `/backbone/assets/audios/${name}`
}
